import React, { useEffect } from 'react';
import { useState } from 'react';
import {
	Badge,
	Typography,
	Upload,
	Spin,
	Modal,
	Form,
	message,
	Space,
	Tooltip,
	Button,
	Card,
	Flex,
	ConfigProvider
} from 'antd';
import { useTranslation } from 'react-i18next';
import {
	CheckOutlined,
	LoadingOutlined,
	CheckCircleOutlined,
	ClockCircleOutlined
} from '@ant-design/icons';
import RenderFiles from './RenderFiles';
import { isMobileOnly } from 'react-device-detect';
import RenderSingFile from './RenderSingFile';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ReduxStore } from '../DocumentBoxesComponent';
import _ from 'lodash';
import moment from 'moment';
import { EyeIcon, InformationCircleIcon } from 'hugeicons-react';
import PdfViewer from './PdfViewer';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import { pdfMap } from './utils/PDFMap';

const { Text } = Typography;

type Props = {
	data: any;
	clickTab: any;
	index: any;
	handleClickPlus: any;
	playToBeforeUpload: any;
	visibleAfterBanksModal: any;
	setVisibleAfterBanksModal: any;
	loader: any;
	valuesData: any;
	modalDocument: any;
	noTypeFile: any;
	dataValueInfoUpload: any;
	documentsRefresh: any;
	env: any;
	images: Images;
	platform: any;
	mortgageData: any;
	mortgageOperation: any;
};

type Images = {
	tesoro: any;
	agencia: any;
	plus: any;
};

const RenderCards = ({
	data,
	clickTab,
	index,
	handleClickPlus,
	playToBeforeUpload,
	visibleAfterBanksModal,
	setVisibleAfterBanksModal,
	loader,
	valuesData,
	modalDocument,
	noTypeFile,
	dataValueInfoUpload,
	documentsRefresh,
	images: { tesoro, agencia, plus },
	env,
	platform,
	mortgageData,
	mortgageOperation
}: Props) => {
	const { t } = useTranslation();
	const [form] = Form.useForm();
	const antIcon = <LoadingOutlined style={{ fontSize: 16 }} spin />;
	const [modalSimpleNote, setModalSimpleNote] = useState(false);
	const [modalSign, setModalSign] = useState(false);
	const [multiBankConsentInfo, setMultiBankConsentInfo] = useState(false);
	const [modalFipre, setModalFipre] = useState(false);
	const userToken = useSelector<ReduxStore, string>((state) => state.auth.token);
	const [fileBank, setFileBank] = useState<any>(undefined);
	const [loading, setLoading] = useState(false);
	const [docSigned, setDocSigned] = useState<any>(undefined);
	const [sabadellSigned, setSabadellSigned] = useState<any>(false);
	const [nameBank, setNameBank] = useState<any>(undefined);
	const params = useParams<any>();
	let dataMortgage = useSelector<ReduxStore, any>((state) => state.data.dataSummary);
	dataMortgage = _.find(dataMortgage, (d) => d.operationId === params.operationId);
	const [countries, setContries] = useState<any>(undefined);
	const [enviroment, setEnviroment] = useState<any>(undefined);
	const [loadingButton, setLoadingButton] = useState(false);
	const [fipreFile, setFipreFile] = useState(undefined);
	const [fipreUrl, setFipreUrl] = useState('');
	const [readComplete, setReadComplete] = useState(false);
	const [requestAppraisal, setRequestAppraisal] = useState(false);
	const [bankNames, setBankNames] = useState([]);
	const [showDocPreview, setShowDocPreview] = useState<boolean>(false);
	const [signedDocData, setSignedDocData] = useState(null);
	const [selectedBank, setSelectedBank] = useState<string | null>(null);
	const [signedDocs, setSignedDocs] = useState(null);

	useEffect(() => {
		axios.get(`${env.api.url}/v1/countries`).then((response) => {
			setContries(response.data.data);
		});
		let enviroment = '';
		if (env.api.url === 'https://dev.api.gibobs.net') {
			setEnviroment('dev');
			enviroment = 'dev';
		} else if (env.api.url === 'https://staging.api.gibobs.net') {
			setEnviroment('staging');
			enviroment = 'staging';
		} else {
			setEnviroment('prod');
			enviroment = 'prod';
		}

		setFileBank(
			`https://gibobs-${enviroment}-cdn.s3.eu-central-1.amazonaws.com/consent-documents/consent-multibank.pdf`
		);
	}, []);

	const saveDataOnClick = (participant: any, key: any, value: any) => {
		let valueRadio = {
			key: 'operation',
			subkey: 'firstClickToAppraisal',
			value: moment().format('YYYY-MM-DD')
		};

		if (
			mortgageData?.reportAppraisal !== undefined &&
			mortgageOperation?.firstClickToAppraisal !== undefined
		) {
			valueRadio = {
				key: 'operation',
				subkey: 'ultimateClickToAppraisal',
				value: moment().format('YYYY-MM-DD')
			};
		}

		axios
			.post(
				`${env.api.url}/v1/mortgages/data/multiple/update/${params.operationId}`,
				{
					values: [
						{
							key: participant,
							subkey: key,
							value: value
						},
						{
							key: valueRadio.key,
							subkey: valueRadio.subkey,
							value: valueRadio.value
						}
					],
					origin: 'https://app.gibobs.com'
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				window.location.reload();
			});
	};

	const renderSign = () => {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', marginTop: 24, marginBottom: 24 }}>
				<RenderSingFile
					setDocSigned={setDocSigned}
					nameBank={nameBank}
					dataMortgage={dataMortgage && dataMortgage}
					clickTab={clickTab}
					form={form}
					countries={countries}
					sabadellSigned={sabadellSigned}
					setSabadellSigned={setSabadellSigned}
					platform={platform}
					env={env}
				/>
			</div>
		);
	};

	const readerPdf = (name: string) => {
		const pdfMap: Record<string, string> = {
			consent_ibercaja: 'consent-ibercaja.pdf',
			consent_caixabank: 'consent-caixa.pdf',
			consent_sabadell: 'consent-sabadell.pdf',
			consent_sabadell_saas: 'consent-sabadell-saas.pdf',
			consent_targobank: 'consent-targobank.pdf',
			consent_caja_rural_sur: 'consent-caja-rural-sur.pdf',
			consent_sabadell_extra: 'consent-sabadell-extra.pdf',
			consent_abanca: 'consent-abanca-saas.pdf',
			consent_bankinter: 'consent-bankinter.pdf',
			consent_engel: 'consent-engel-1.pdf',
			consent_sc_es: 'consent-safecredit.pdf',
			consent_globalcaja: 'consent-globalcaja.pdf',
			consent_bbva: 'consent-bbva.pdf',
			consent_kutxabank: 'consent-kutxabank.pdf'
		};
		if (name === 'consent_multibank') {
			// Alternativa usando data URL
			setLoading(true);
			setNameBank(name);
			handleClickPlus(data.name);

			setNameBank('consent_multibank');
			setFileBank(
				`https://gibobs-${enviroment}-cdn.s3.eu-central-1.amazonaws.com/consent-documents/consent-multibank.pdf`
			);
			setModalSign(true);

			/*axios
				.get(`${env.api.url}/docs/documents/multibank/preview/${params.operationId}`, {
					headers: { Authorization: `Bearer ${userToken}` },
					responseType: 'arraybuffer'
				})
				.then((response) => {
					// Convertir a base64
					const base64 = btoa(
						new Uint8Array(response.data).reduce(
							(data, byte) => data + String.fromCharCode(byte),
							''
						)
					);
					const pdfUrl = `data:application/pdf;base64,${base64}`;
					setFileBank(pdfUrl);
				})
				.catch((error) => {
					console.error('Error al traer el documento consent_multibanks:', error);
					message.error(t('m_common.requestErrorTitle'));
					setLoading(false);
				});*/
		} else if (name === 'fipre_sabadell') {
			axios
				.get(`${env.api.url}/sb/mortgages/fipre-url/${params.operationId}`, {
					headers: { Authorization: `Bearer ${userToken}` }
				})
				.then((response) => {
					const pdfUrl = response?.data?.data;
					handleClickPlus(data.name);
					setFipreUrl(pdfUrl);
					axios.get(pdfUrl, { responseType: 'arraybuffer' }).then((res) => {
						const blob = new Blob([res.data], { type: 'application/pdf' });
						const file = new File([blob], 'fipre_sabadell.pdf', { type: 'application/pdf' });
						setFipreFile(file);
					});
				})
				.catch((error) => console.error('Error al traer el documento FIPRE:', error));
		} else {
			const fileName = pdfMap[name];
			if (fileName) {
				setFileBank(
					`https://gibobs-${enviroment}-cdn.s3.eu-central-1.amazonaws.com/consent-documents/${fileName}`
				);
				setLoading(true);
				setNameBank(name);
				setModalSign(true);
			}
		}
	};

	const buildOwnerData = (values: Record<string, any>) => {
		// Creamos el array a partir de las entries
		const dataArr = Object.entries(values)
			.map(([subkey, value]) => ({
				key: clickTab, // asignamos un owner por defecto
				subkey,
				value
			}))
			// Filtramos campos sensibles enmascarados
			.filter(
				(item) => !(['nif', 'email', 'phone'].includes(item.subkey) && item.value?.includes('**'))
			);

		return dataArr;
	};

	const sendSign = () => {
		if (nameBank === 'consent_multibank') {
			form
				.validateFields()
				.then((values) => {
					setLoadingButton(true);
					const ownersData = buildOwnerData(values);
					axios
						.post(
							`${env.api.url}/v1/mortgages/data/multiple/update/${params.operationId}`,
							{ values: ownersData },
							{ headers: { Authorization: `Bearer ${userToken}` } }
						)
						.then((response) => {
							if (response.data.success) {
								form.resetFields();
								signFile();
							} else {
								setLoadingButton(false);
								message.error(t('m_common.requestErrorTitle'));
							}
						})
						.catch((err) => {
							setLoadingButton(false);
							console.log('error:', err);
							message.error(t('m_common.requestErrorTitle'));
						});
				})
				.catch((err) => {
					if (err && err.outOfDate) {
						console.log('Validation outOfDate, ignoring...', err);
						return;
					}
					setLoadingButton(false);
					console.log('error:', err);
					message.error(t('form.fillAllOwners'));
				});
		}
		if (nameBank === 'consent_abanca') {
			form
				.validateFields()
				.then((values) => {
					setLoadingButton(true);
					const ownersData = buildOwnerData(values);
					axios
						.post(
							`${env.api.url}/v1/mortgages/data/multiple/update/${params.operationId}`,
							{ values: ownersData },
							{ headers: { Authorization: `Bearer ${userToken}` } }
						)
						.then((response) => {
							if (response.data.success) {
								form.resetFields();
								signFile();
							} else {
								setLoadingButton(false);
								message.error(t('m_common.requestErrorTitle'));
							}
						})
						.catch((err) => {
							setLoadingButton(false);
							console.log('error:', err);
							message.error(t('m_common.requestErrorTitle'));
						});
				})
				.catch((err) => {
					setLoadingButton(false);
					console.log('error:', err);
					message.error(t('form.fillAllOwners'));
				});
		} else if (nameBank === 'consent_kutxabank') {
			form
				.validateFields()
				.then((values) => {
					setLoadingButton(true);

					const ownersData = buildOwnerData(values);

					axios
						.post(
							`${env.api.url}/v1/mortgages/data/multiple/update/${params.operationId}`,
							{ values: ownersData },
							{ headers: { Authorization: `Bearer ${userToken}` } }
						)
						.then((response) => {
							if (response.data.success) {
								form.resetFields();
								signFile();
							} else {
								setLoadingButton(false);
								message.error(t('m_common.requestErrorTitle'));
							}
						})
						.catch((err) => {
							setLoadingButton(false);
							console.log('error:', err);
							message.error(t('m_common.requestErrorTitle'));
						});
				})
				.catch((err) => {
					setLoadingButton(false);
					console.log('error:', err);
					message.error(t('form.fillAllOwners'));
				});
		} else if (nameBank !== 'consent_caixabank') {
			form
				.validateFields()
				.then((values) => {
					setLoadingButton(true);
					let data = [
						{
							key: clickTab,
							subkey: 'name',
							value: values.name
						},
						{
							key: clickTab,
							subkey: 'firstSurname',
							value: values.firstSurname
						},
						{
							key: clickTab,
							subkey: 'lastSurname',
							value: values.lastSurname
						},
						{
							key: clickTab,
							subkey: 'nif',
							value: values.nif
						},
						{
							key: clickTab,
							subkey: 'birthdate',
							value: moment(values?.birthdate, 'DD-MM-YYYY').format('YYYY-MM-DD')
						},
						{
							key: clickTab,
							subkey: 'email',
							value: values.email
						},
						{
							key: clickTab,
							subkey: 'phone',
							value: values.phone
						},
						{
							key: clickTab,
							subkey: 'address',
							value: values.address
						},
						{
							key: clickTab,
							subkey: 'population',
							value: values.population
						},
						{
							key: clickTab,
							subkey: 'province',
							value: values.province
						},
						{
							key: clickTab,
							subkey: 'postalCode',
							value: values.postalCode
						},

						{
							key: clickTab,
							subkey: 'cityzenship',
							value: values.cityzenship
						},
						{
							key: clickTab,
							subkey: 'birthCountry',
							value: values.birthCountry
						},
						{
							key: clickTab,
							subkey: 'taxResidency',
							value: values.taxResidency
						},
						{
							key: clickTab,
							subkey: 'nationality',
							value: values.nationality
						},
						{
							key: clickTab,
							subkey: 'maritalStatus',
							value: values.maritalStatus
						}
					];

					if (values.nif?.includes('**')) {
						data = data.filter((item) => item.subkey !== 'nif');
					}
					if (values?.email?.includes('**')) {
						data = data.filter((item) => item.subkey !== 'email');
					}
					if (values?.phone?.includes('**')) {
						data = data.filter((item) => item.subkey !== 'phone');
					}

					data = data.filter((item) => item.value !== undefined && item.value !== 'Invalid date');
					axios
						.post(
							`${env.api.url}/v1/mortgages/data/multiple/update/${params.operationId}`,
							{ values: data },
							{ headers: { Authorization: `Bearer ${userToken}` } }
						)
						.then((response) => {
							if (response.data.success) {
								form.resetFields();
								signFile();
							} else {
								setLoadingButton(false);
								message.error(t('m_common.requestErrorTitle'));
							}
						});
				})
				.catch((errors) => {
					setLoadingButton(false);
					console.error('Errores de validación:', errors);
				});
		} else {
			if (nameBank !== 'consent_sabadell') {
				setLoadingButton(true);
				signFile();
			}
			if (nameBank === 'consent_sabadell') {
				setModalSign(false);
				setFileBank(undefined);

				dataValueInfoUpload();
				documentsRefresh();
			}
		}
	};

	const signFile = () => {
		setModalSign(false);
		setFileBank(undefined);
		setLoadingButton(false);
		if (nameBank === 'consent_sabadell') {
			if (sabadellSigned) {
				axios
					.post(
						`${env.api.url}/docs/documents/sign-document`,
						{
							operationId: params.operationId,
							owner: clickTab,
							consentCheck: sabadellSigned,
							typeDocument: nameBank
						},
						{
							headers: { Authorization: `Bearer ${userToken}` }
						}
					)
					.then((response) => {
						setDocSigned(true);
						dataValueInfoUpload('consent');
						documentsRefresh();
					});
			}
		} else {
			axios
				.post(
					`${env.api.url}/docs/documents/sign-document`,
					{
						operationId: params.operationId,
						owner: clickTab,
						sign: docSigned,
						typeDocument: nameBank === 'consent_abanca' ? 'consent_abanca_saas' : nameBank
					},
					{ headers: { Authorization: `Bearer ${userToken}` } }
				)
				.then((response) => {
					dataValueInfoUpload();
					documentsRefresh();
				});
		}
	};

	const renderImage = (data: any) => {
		if (data?.name === 'consent_caixabank') {
			return 'caixabank_iso.png';
		} else if (data?.name === 'consent_ibercaja') {
			return 'ibercaja_iso.png';
		} else if (data?.name === 'consent_targobank') {
			return 'targobank_iso.png';
		} else if (data?.name === 'consent_sabadell') {
			return 'sabadell_iso.png';
		} else if (data?.name === 'consent_sabadell_saas') {
			return 'sabadell_iso.png';
		} else if (data?.name === 'consent_abanca') {
			return 'abanca_iso.png';
		} else if (data?.name === 'consent_caja_rural_sur') {
			return 'cajaruralsur_iso.png';
		} else if (data?.name === 'consent_bankinter') {
			return 'bankinter_iso.png';
		} else if (data?.name === 'consent_globalcaja') {
			return 'globalcaja_iso.png';
		} else if (data?.name === 'consent_multibank') {
			return 'gibobs_iso.png';
		} else if (data?.name === 'consent_bbva') {
			return 'bbva_iso.png';
		} else if (data?.name === 'consent_kutxabank') {
			return 'kutxabank_iso.png';
		} else if (data?.name === 'consent_engel') {
			return '';
		} else {
			return 'cajaruralsur_iso.png';
		}
	};

	const renderBigImage = (data: any) => {
		if (data === 'consent_caixabank') {
			return 'caixabank.png';
		} else if (data === 'consent_ibercaja') {
			return 'ibercaja.png';
		} else if (data === 'consent_targobank') {
			return 'targobank.png';
		} else if (data === 'consent_sabadell') {
			return 'sabadell.png';
		} else if (data === 'consent_sabadell_saas') {
			return 'sabadell.png';
		} else if (data === 'consent_caja_rural_sur') {
			return 'cajaruralsur.png';
		} else if (data === 'consent_bankinter') {
			return 'bankinter.png';
		} else if (data === 'consent_globalcaja') {
			return 'globalcaja.png';
		} else if (data === 'consent_multibank') {
			return 'gibobs.png';
		} else if (data === 'consent_abanca') {
			return 'abanca.png';
		} else if (data === 'consent_kutxabank') {
			return 'kutxabank.png';
		} else if (data === 'consent_bbva') {
			return 'bbva.png';
		} else {
			return 'cajaruralsur.png';
		}
	};

	const renderColor = () => {
		if (platform === 'sabadell') {
			return '#006DFF';
		} else if (platform === 'engel') {
			return '#C80000';
		} else if (platform === 'safecredit') {
			return '#002087';
		} else {
			return '#02C3CD';
		}
	};

	const renderCircleIcon = () => {
		return (
			<Tooltip
				title={platform !== 'sabadell' ? t('documen.payrollGibobs') : t('documen.payrollSabadell')}>
				<InformationCircleIcon
					size={16}
					color={'#262626'}
					style={{ marginTop: 2 }}></InformationCircleIcon>
			</Tooltip>
		);
	};

	const renderInformationIcon = () => {
		return (
			<Tooltip
				title={
					mortgageData?.reportAppraisal === undefined
						? t('info.appraisalIcon')
						: t('info.appraisalIcon3')
				}>
				<span>
					<InformationCircleIcon
						size={16}
						color={'#262626'}
						style={{ marginTop: 2, width: '15px', height: '15px' }}
						onClick={fetchBanksNames}
					/>
				</span>
			</Tooltip>
		);
	};

	const renderInformationIconMulti = () => {
		return (
			<Tooltip title={t('consent.multi')}>
				<span>
					<InformationCircleIcon
						size={16}
						color={'#262626'}
						style={{ marginTop: 2, width: '15px', height: '15px' }}
						onClick={fetchBanksNames}
					/>
				</span>
			</Tooltip>
		);
	};

	const fetchBanksNames = () => {
		setMultiBankConsentInfo(true);
		axios
			.get(`${env.api.url}/docs/documents/consent-types/${params.operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setBankNames(response.data.data);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const renderText = () => {
		if (platform !== 'sabadell') {
			return <Text className="attach-document-text">{t('documen.payrollGibobsButton')}</Text>;
		} else {
			return <Text className="attach-document-text">{t('documen.payrollSabadellButton2')}</Text>;
		}
	};

	const renderTextAppraisal = (mortgageData: any) => {
		if (mortgageData?.appraisalPaid) {
			return t('info.appraisalIcon6');
		} else {
			if (_.isNil(mortgageData?.appraisalAmount)) {
				return t('info.appraisalIcon2');
			} else {
				return t('info.appraisalIcon4');
			}
		}
	};

	const fetchSignedDocuments = () => {
		if (bankNames.length === 0) fetchBanksNames();
		axios
			.get(`${env.api.url}/v1/documents/get-all-documents-url/${params.operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((res) => {
				const mapped = Object.fromEntries(res.data.data.map((doc: any) => [doc.type, doc]));
				setSignedDocs(mapped as any);
				setMultiBankConsentInfo(true);
			});
	};

	const renderDocPreview = async (name: string) => {
		setSelectedBank(name);
		const defaultFileName = pdfMap[name];

		if (signedDocs !== null && signedDocs[name]) {
			const signedData: any = signedDocs[name];
			try {
				const responseFile = await axios.get(signedData.url, { responseType: 'blob' });
				setSignedDocData({
					url: signedData.url,
					mime: signedData.mime,
					fileData: responseFile.data
				} as any);
				setDocPreview('');
			} catch (error) {
				console.error('Error blob doc', error);
			}
		} else if (defaultFileName) {
			const url = `https://gibobs-${enviroment}-cdn.s3.eu-central-1.amazonaws.com/consent-documents/${defaultFileName}`;
			try {
				const responseFile = await axios.get(url, { responseType: 'blob' });
				setSignedDocData({
					url: url,
					mime: 'application/pdf',
					fileData: responseFile.data
				} as any);
				setDocPreview('');
			} catch (error) {
				console.error('Error blob doc', error);
			}
		}
		setShowDocPreview(true);
		setLoading(false);
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				height: '100%'
			}}>
			<div
				className="wrapper-flex"
				style={{
					alignItems: 'flex-start'
				}}>
				{noTypeFile === undefined && data?.name !== 'appraisal' && (
					<div>
						<div
							className="wrapper-icons-render-cards"
							style={{
								marginTop: loader && -4
							}}>
							{!loader &&
								(data?.completed[clickTab] === false ? (
									<Badge
										dot={true}
										size="small"
										className="gb-badget"
										style={{ marginTop: 10 }}></Badge>
								) : (
									<CheckCircleOutlined
										className="gb-check"
										style={{ fontSize: 15, color: platform === 'engel' && '#477306' }}
									/>
								))}
							{loader && <Spin indicator={antIcon} className="spin" />}
						</div>
					</div>
				)}
				{data?.name === 'appraisal' && (
					<div>
						<div
							className="wrapper-icons-render-cards"
							style={{
								marginTop: loader && -4
							}}>
							{!loader &&
								(mortgageData?.reportAppraisal === undefined ? (
									<Badge dot={true} size="small" color="#FF4D4F"></Badge>
								) : mortgageData?.appraisalPaid ? (
									<CheckCircleOutlined
										className="gb-check"
										style={{ fontSize: 15, color: platform === 'engel' && '#477306' }}
									/>
								) : (
									<ClockCircleOutlined size={16} style={{ color: '#0088C6' }} />
								))}
							{loader && <Spin indicator={antIcon} className="spin" />}
						</div>
					</div>
				)}

				{noTypeFile !== undefined && (
					<div>
						<div
							className="wrapper-icons-render-cards"
							style={{
								marginTop: loader && -4
							}}>
							{!loader &&
								(noTypeFile === undefined ? (
									<Badge dot={true} size="small" color="#FF4D4F"></Badge>
								) : (
									<CheckOutlined
										style={{ color: platform === 'engel' && '#477306', fontSize: 10 }}
									/>
								))}
							{loader && <Spin indicator={antIcon} className="spin" />}
						</div>
					</div>
				)}

				<div style={{ display: 'flex' }}>
					<div>
						{data?.name === 'docs.othersDocs' ? (
							<Text className="render-card-name">{t(`${data?.name}`, data?.title)}</Text>
						) : data?.name === 'consent_sabadell' && platform === 'sabadell' ? (
							<Text className="render-card-name">{t('data.consent')}</Text>
						) : (
							<Text className="render-card-name">
								{platform === 'gibobs'
									? data.name === 'bankreader'
										? t('doc.differentStages3Automatic')
										: data.name === 'nif'
										? t('form.dni')
										: data.name === 'laboralLife'
										? t('newDoc.laboralLife')
										: data.name === 'payroll'
										? t('newDoc.payroll')
										: t(`documentTypes.${data?.name}`, data?.title)
									: t(`documentTypes.${data?.name}`, data?.title)}{' '}
							</Text>
						)}
						{data?.name === 'bankreader' && <Text className="render-card-name">*</Text>}
					</div>
					{data?.name === 'payroll' && renderCircleIcon()}
					{data?.name === 'appraisal' && renderInformationIcon()}
					{data?.name === 'consent_multibank' && renderInformationIconMulti()}
				</div>
			</div>
			<div style={{ marginBottom: platform === 'engel' ? 30 : 50, marginLeft: 16, marginTop: 16 }}>
				<RenderFiles
					clickTab={clickTab}
					file={data}
					valuesData={valuesData}
					modalDocument={modalDocument}
					env={env}
					platform={platform}
				/>
			</div>
			{/* Card de adjuntar documento */}
			{`documentTypes.${data?.name}` !== 'documentTypes.simpleNote' &&
				`documentTypes.${data?.name}` !== 'documentTypes.fipre_sabadell' &&
				`documentTypes.${data?.name}` !== 'documentTypes.appraisal' &&
				// `documentTypes.${data?.name}` !== 'documentTypes.bankreader' &&
				!data.name.includes('consent') && (
					<div
						className="wrapper-flex"
						style={{
							justifyContent: 'space-between',
							marginLeft: 16,
							position: 'absolute',
							bottom: 16,
							width: '85%'
						}}>
						<Upload
							multiple={true}
							beforeUpload={(file) => playToBeforeUpload(file, data, index)}
							aria-label={t('file.newOnboardingDocs')}>
							<Button
								type="text"
								style={{ border: 'none', boxShadow: 'none', padding: 0 }}
								onClick={() => handleClickPlus(data?.name)}
								className="wrapper-flex">
								{platform !== 'engel' && platform !== 'safecredit' && (
									<div
										style={{
											height: 16,
											width: 16,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											marginRight: 4
										}}>
										<img
											src={plus}
											alt="plus"
											height={11}
											style={{
												height: platform === 'sabadell' ? 16 : 24,
												width: platform === 'sabadell' ? 16 : 24
											}}
										/>
									</div>
								)}
								{platform === 'engel' && (
									<Text style={{ fontSize: 16, color: '#C80000' }}>{'+'}</Text>
								)}
								{platform === 'safecredit' && (
									<Text style={{ fontSize: 16, color: '#002087' }}>{'+'}</Text>
								)}
								{data?.name === 'payroll' ? (
									renderText()
								) : (
									<Text className="attach-document-text">{t('file.newOnboardingDocs')}</Text>
								)}
							</Button>
						</Upload>
						<div>
							{(data?.name === 'laboralLife' || data?.name === 'contributionBase') && (
								<img src={tesoro} alt="tesoro" style={{ height: 16, width: 16 }}></img>
							)}
							{(data?.name === 'irpf2' ||
								data?.name === 'irpf' ||
								data?.name === 'statement303' ||
								data?.name === 'statement130') && (
								<img src={agencia} alt="agencia" style={{ height: 16, width: 16 }}></img>
							)}
						</div>
					</div>
				)}
			{/* Card de "Conseguir aquí o Adjuntar documento" */}
			{`documentTypes.${data?.name}` === 'documentTypes.simpleNote' &&
				// || `documentTypes.${data?.name}` === 'documentTypes.bankreader'
				!data.name.includes('consent') && (
					<div
						style={{
							marginLeft: 16,
							gap: 4,
							display: 'flex',
							flexWrap: 'wrap',
							position: 'absolute',
							bottom: 16,
							width: '85%'
						}}>
						<Button
							type="text"
							style={{ border: 'none', boxShadow: 'none', padding: 0 }}
							onClick={() =>
								`documentTypes.${data?.name}` === 'documentTypes.simpleNote'
									? setModalSimpleNote(true)
									: setVisibleAfterBanksModal(!visibleAfterBanksModal)
							}
							className="attach-document-text">
							{t('doc.newBankflipButton')}&nbsp;
						</Button>
						<Space>
							<div style={{ verticalAlign: 'middle' }}>o</div>
							<Upload
								multiple={true}
								beforeUpload={(file) => playToBeforeUpload(file, data)}
								aria-label={t('file.newOnboardingDocs')}>
								<Button
									type="text"
									style={{ border: 'none', boxShadow: 'none', padding: 0 }}
									onClick={() => handleClickPlus(data?.name)}
									className="wrapper-flex">
									{platform !== 'engel' && platform !== 'safecredit' && (
										<div
											style={{
												height: 16,
												width: 16,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												marginRight: 4
											}}>
											<img
												src={plus}
												alt="plus"
												height={11}
												style={{
													height: platform === 'sabadell' ? 16 : 24,
													width: platform === 'sabadell' ? 16 : 24
												}}
											/>
										</div>
									)}
									{platform === 'engel' && (
										<Text style={{ fontSize: 16, color: '#C80000' }}>{'+'}</Text>
									)}
									{platform === 'safecredit' && (
										<Text style={{ fontSize: 16, color: '#002087' }}>{'+'}</Text>
									)}
									<Text className="attach-document-text">{t('file.newOnboardingDocs')}</Text>
								</Button>
							</Upload>
						</Space>
					</div>
				)}
			{/* Card de "Leer y firmar" / "Leer y aceptar"*/}
			{`documentTypes.${data?.name}` !== 'documentTypes.bankreader' &&
				`documentTypes.${data?.name}` !== 'documentTypes.simpleNote' &&
				(data.name === 'fipre_sabadell' || data.name.includes('consent')) && (
					<div
						className="wrapper-flex"
						style={{
							justifyContent: 'space-between',
							marginLeft: 16,
							position: 'absolute',
							bottom: 16,
							width: '85%'
						}}>
						{data.completed[clickTab] === false ? (
							<Button
								className="attach-document-text"
								icon={
									<EyeIcon style={{ color: renderColor(), verticalAlign: 'middle' }} size={16} />
								}
								type="text"
								style={{ border: 'none', boxShadow: 'none', padding: 0 }}
								onClick={() => {
									readerPdf(data.name);
									if (data.name === 'fipre_sabadell') setModalFipre(true);
								}}>
								{data.name === 'fipre_sabadell' ? t('docs.readAndAccept') : t('docs.readAndSing')}
							</Button>
						) : (
							data.name === 'consent_multibank' && (
								<Button
									type="text"
									icon={<EyeIcon size={16} />}
									onClick={fetchSignedDocuments}
									className="attach-document-text"
									style={{ padding: 0, marginTop: -24 }}>
									{t('check.SignedConsents')}
								</Button>
							)
						)}
						{data.completed[clickTab] === false &&
							!['fipre_sabadell', 'consent_multibank'].includes(data.name) && (
								<img
									src={`https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/images/banks/${renderImage(
										data
									)}`}
									height={20}
									alt="bank"
								/>
							)}
					</div>
				)}
			{`documentTypes.${data?.name}` === 'documentTypes.appraisal' &&
				mortgageData?.reportAppraisal === undefined && (
					<div
						style={{
							marginLeft: 16,
							gap: 4,
							display: 'flex',
							flexWrap: 'wrap',
							position: 'absolute',
							bottom: 16
						}}>
						<Text onClick={() => setRequestAppraisal(true)} className="attach-document-text">
							{t('appraisal.requestAppraisalButton')}&nbsp;
						</Text>
						<Space>
							<div style={{ verticalAlign: 'middle' }}>o</div>
							<Upload
								multiple={true}
								beforeUpload={(file) => playToBeforeUpload(file, data)}
								aria-label={t('file.newOnboardingDocs')}>
								<div onClick={() => handleClickPlus(data?.name)} className="wrapper-flex">
									<Text className="attach-document-text">{t('file.newOnboardingDocs')}</Text>
								</div>
							</Upload>
						</Space>
					</div>
				)}{' '}
			{`documentTypes.${data?.name}` === 'documentTypes.appraisal' &&
				mortgageData?.reportAppraisal === 'h1' && (
					<div
						style={{
							marginLeft: 16,
							marginRight: 16,
							gap: 4,
							display: 'flex',
							flexWrap: 'wrap',
							position: 'absolute',
							bottom: 16
						}}>
						<Text style={{ fontWeight: 400, color: '#748EA0', fontSize: 12 }}>
							{renderTextAppraisal(mortgageData)}
						</Text>
					</div>
				)}
			<Modal
				className="ModalDesktopCert"
				title={t('doc.modalSimpleNoteTitle')}
				open={modalSimpleNote}
				onCancel={() => setModalSimpleNote(false)}
				onOk={() => {
					window.open('https://www.tinsa.es/store/nota-simple/', '_blank');
					setModalSimpleNote(false);
				}}
				cancelButtonProps={{
					style: { display: 'none' }
				}}
				okButtonProps={{
					className: platform === 'engel' ? 'button-primary-engel' : 'button-primari-gibobs',
					style: { width: '100%', marginLeft: 0 }
				}}
				okText={t('doc.modalSimpleNoteButton')}
				destroyOnClose={true}
				closable={true}
				centered
				width={470}>
				<div
					style={{
						color: platform === 'engel' ? '#808080' : '#748EA0',
						fontSize: 14,
						fontWeight: 400,
						marginTop: 24
					}}
					dangerouslySetInnerHTML={{
						__html:
							platform === 'sabadell'
								? t('doc.modalSimpleNoteSabadell')
								: t('doc.modalSimpleNoteDescription')
					}}></div>
				<div
					style={{
						color: platform === 'engel' ? '#808080' : '#748EA0',
						fontSize: 10,
						fontWeight: 400,
						marginTop: 12,
						marginBottom: 10
					}}
					dangerouslySetInnerHTML={{
						__html: t('doc.modalSimpleNoteExplination')
					}}></div>
			</Modal>
			<Modal
				className="ModalDesktopCert"
				title={t('doc.sign')}
				open={modalSign}
				onCancel={() => {
					setModalSign(false);
					// Limpiar la URL del blob si existe
					if (fileBank && fileBank.startsWith('blob:')) {
						window.URL.revokeObjectURL(fileBank);
					}
					setFileBank(undefined);
					form.resetFields();
				}}
				onOk={() => sendSign()}
				cancelButtonProps={{
					style: { display: 'none' }
				}}
				okButtonProps={{
					className: 'button-primari-gibobsNew',
					disabled:
						nameBank === 'consent_sabadell'
							? !sabadellSigned
							: docSigned !== undefined
							? false
							: true,
					style: { width: '100%', marginLeft: 0 },
					loading: loadingButton
				}}
				okText={t('offers.accept')}
				forceRender={true}
				destroyOnClose={true}
				closable={true}
				centered
				width={isMobileOnly ? '100%' : '50%'}>
				{loading && fileBank ? (
					<div>
						<iframe src={fileBank} style={{ height: 500, width: '100%', border: 'none' }}></iframe>
					</div>
				) : (
					<Spin indicator={antIcon} className="spin" />
				)}

				{modalSign && renderSign()}
			</Modal>
			<Modal
				className="ModalDesktopCert"
				title={<Text style={{ color: '#212121', fontSize: 16 }}>{t('offers.accept')} FIPRE</Text>}
				open={modalFipre}
				onCancel={() => {
					setModalFipre(false);
					setFipreUrl(undefined);
					setFipreFile(undefined);
				}}
				onOk={() => {
					playToBeforeUpload(fipreFile, data);
					setModalFipre(false);
				}}
				cancelButtonProps={{
					style: { display: 'none' }
				}}
				okButtonProps={{
					className: 'button-primari-gibobs',
					style: { margin: '0 auto', marginTop: 24, width: 120 },
					disabled: !readComplete
				}}
				okText={t('offers.accept')}
				forceRender={true}
				destroyOnClose={true}
				closable={true}
				centered
				width={isMobileOnly ? '100%' : '50%'}>
				{fipreUrl ? (
					<>
						<Text style={{ color: '#757575' }}>{t('docs.mustRead')}</Text>
						<div style={{ marginTop: 24 }}>
							<PdfViewer fileUrl={fipreUrl} setReadComplete={setReadComplete} />
						</div>
					</>
				) : (
					<Spin indicator={antIcon} className="spin" />
				)}
			</Modal>
			<Modal
				className="ModalDesktopCert"
				title={
					<Text style={{ color: '#212121', fontSize: 16 }}>{t('appraisal.infoAppraisal')}</Text>
				}
				open={requestAppraisal}
				onCancel={() => {
					setRequestAppraisal(false);
				}}
				onOk={() => {
					saveDataOnClick('mortgage', 'reportAppraisal', 'h1');
					setRequestAppraisal(false);
				}}
				cancelButtonProps={{
					style: { display: 'none' }
				}}
				okButtonProps={{
					className: 'button-primari-gibobs',
					style: { marginLeft: 0, width: '100%' }
				}}
				okText={t('document.solicitar')}
				forceRender={true}
				destroyOnClose={true}
				closable={true}
				centered
				width={isMobileOnly ? '100%' : 480}>
				<div style={{ marginBottom: 24 }}>
					<Text style={{ fontSize: 14, color: '#2F4858', fontWeight: 400 }}>
						{t('resquet.init')}
					</Text>
				</div>
			</Modal>
			<Modal
				className="ModalDesktopCert"
				title={
					<div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
						<Text style={{ fontSize: 20, color: '#2f4858', fontWeight: 600 }}>
							{data?.completed[clickTab] !== false
								? t('consentSigned.title')
								: t('consentToSign.title')}
						</Text>
					</div>
				}
				open={multiBankConsentInfo}
				onCancel={() => {
					setMultiBankConsentInfo(false);
				}}
				onOk={() => {
					setMultiBankConsentInfo(false);
				}}
				cancelButtonProps={{
					style: { display: 'none' }
				}}
				okButtonProps={{
					style: { display: 'none' }
				}}
				//okText={t('document.solicitar')}
				forceRender={true}
				destroyOnClose={true}
				closable={true}
				centered
				width={isMobileOnly ? '100%' : '70%'}
				style={{ marginTop: '20px', marginBottom: '20px' }}>
				<div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
					<Text style={{ fontSize: 14, color: '#748EA0', fontWeight: 400 }}>
						{t('consentToSign.description')}
					</Text>
					<div
						style={{
							display: 'flex',
							flexDirection: isMobileOnly ? 'column' : undefined,
							gap: 20,
							height: '80vh',
							overflow: 'hidden'
						}}>
						<div
							style={{
								display: 'flex',
								flexDirection: isMobileOnly ? undefined : 'column',
								gap: '12px',
								height: isMobileOnly ? undefined : '100%',
								overflowY: 'auto',
								paddingRight: '10px',
								minWidth: isMobileOnly ? undefined : '220px',
								paddingBottom: '20px'
							}}>
							{bankNames.map((name) => {
								const isSelected = selectedBank === name;
								return (
									<Card
										key={name}
										hoverable
										style={{
											width: isMobileOnly ? 150 : '200px',
											height: isMobileOnly ? 60 : '80px',
											flexShrink: 0,
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											padding: '10px',
											boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
											cursor: 'pointer',
											background: isSelected ? '#B8DEEF' : undefined,
											border: isSelected ? '1px solid #748EA0' : undefined
										}}
										onClick={() => renderDocPreview(name)}>
										<img
											src={`https://gibobs-prod-cdn.s3.eu-central-1.amazonaws.com/images/banks/${renderBigImage(
												name
											)}`}
											alt={`Logo de ${name}`}
											style={{
												maxWidth: '100%',
												maxHeight: '100%',
												objectFit: 'contain'
											}}
										/>
									</Card>
								);
							})}
						</div>

						{/* Visualizador de Documentos: Sin scroll horizontal */}
						<div
							style={{
								flex: 1,
								height: '100%',
								overflow: 'hidden',
								marginBottom: isMobileOnly ? '50px' : undefined
							}}>
							{showDocPreview && signedDocData ? (
								<DocViewer
									className="doc-view-modal"
									style={{
										height: '100%',
										width: '100%',
										overflowX: 'hidden'
									}}
									pluginRenderers={DocViewerRenderers}
									config={{
										header: {
											disableHeader: true
										}
									}}
									documents={[
										{
											uri: (signedDocData as any).url,
											fileType: (signedDocData as any).mime,
											fileData: (signedDocData as any).fileData
										}
									]}
								/>
							) : (
								<div
									style={{
										height: '100%',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										border: '1px dashed #748EA0',
										borderRadius: '8px'
									}}>
									<Text style={{ color: '#748EA0' }}>{t('document.NotAvailable')}</Text>
								</div>
							)}
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default RenderCards;
